import Cookies from 'js-cookie'
import { createRouter, createWebHistory } from 'vue-router'
import { updateUserNotificationById } from '../api/user'
import { useInstallationStore } from '../stores/installation'
import { useUserStore } from '../stores/user'
import { setDocumentTitlePage } from '../views/common'
import { getPreferenceValue } from './../components/preferences'

const Login = () => import('../views/Login.vue')

const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '../views/All/Dashboard.vue')
const Bookmarks = () => import(/* webpackChunkName: "bookmarks" */ '../views/All/Bookmarks.vue')
const Build = () => import(/* webpackChunkName: "build" */ '../views/All/Build.vue')
const SharedCode = () => import(/* webpackChunkName: "sharedcode" */ '../views/All/SharedCode.vue')
const Diff = () => import(/* webpackChunkName: "diff" */ '../views/All/Diff.vue')
const Runs = () => import(/* webpackChunkName: "history" */ '../views/All/Runs.vue')
const Swagger = () => import(/* webpackChunkName: "swagger" */ '../views/All/Swagger.vue')
const Frontends = () => import(/* webpackChunkName: "frontends" */ '../views/All/Frontends.vue')

const Vault = () => import(/* webpackChunkName: "vault" */ '../views/Admin/Vault.vue')
const Migrate = () => import(/* webpackChunkName: "migrate" */ '../views/Admin/Migrate.vue')
const Log = () => import(/* webpackChunkName: "log" */ '../views/Admin/Log.vue')

const ProfileContainer = () => import(/* webpackChunkName: "profile" */ '../views/All/ProfileContainer.vue')
const Preferences = () => import(/* webpackChunkName: "preferences" */ '../views/All/Preferences.vue')

const SignUp = () => import(/* webpackChunkName: "Signup" */ '../views/Admin/SignUp.vue')
const ResetPassword = () => import(/* webpackChunkName: "ResetPassword" */ '../views/All/ResetPassword.vue')
const InviteStepper = () => import(/* webpackChunkName: "InviteStepper" */ '../views/Admin/InviteStepper.vue')
const SchedulerView = () => import(/* webpackChunkName: "SchedulerView" */ '../components/schedule/IntegrationSchedulerView.vue')
const ScheduleDashboard = () => import(/* webpackChunkName: "ScheduleDashboard" */ '../components/schedule/ScheduleDashboard.vue')

const CatalogView = () => import(/* webpackChunkName: "CatalogView" */ '../views/Admin/CatalogView.vue')
const Mapping = () => import(/* webpackChunkName: "Mapping" */ '../views/All/Mapping.vue')
const Workbench = () => import(/* webpackChunkName: "Workbench" */ '../views/All/Workbench.vue')
const WorkbenchWelcome = () => import(/* webpackChunkName: "Workbench" */ '../components/workbench/welcome/WelcomeOverlay.vue')
const WorkbenchCanvas = () => import(/* webpackChunkName: "Workbench" */ '../components/workbench/canvas/Canvas.vue')

import { routes as etlRoutes } from "./etl_routes"


export const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
    props: true,
    meta: {
      title: 'Login'
    }
  },
  {
    path: "/catalog",
    name: "catalog",
    component: CatalogView,
    // props: true,
    meta: {
      title: 'Catalog',
      requiresAuth: true,
    }
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    meta: {
      title: "Dashboard",
      requiresAuth: true
    }
  },
  {
    path: '/bookmarks',
    name: 'bookmarks',
    component: Bookmarks,
    meta: {
      title: 'Bookmarks',
      requiresAuth: true
    }
  },
  {
    path: '/build',
    name: 'build',
    component: Build,
    meta: {
      title: 'Build',
      requiresAuth: true
    }
  },
  {
    path: '/mapping/:integrationPathName?/:srId?',
    name: 'mapping',
    component: Mapping,
    meta: {
      title: 'Mapping',
      requiresAuth: true,
      requiresMappingEnabled: true
    },
  },
  {
    path: '/shared-code',
    name: 'shared-code',
    component: SharedCode,
    meta: {
      title: 'Shared Code',
      requiresAuth: true,
      requiresAnyPermission: ["can_use_shared_modules", "can_use_custom_adapters"]
    }
  },
  {
    path: '/diff',
    name: 'diff',
    component: Diff,
    meta: {
      title: 'Diff',
      requiresAuth: true,
      requiresPermissions: ["can_use_migrate"]
    }
  },
  {
    path: '/history',
    name: 'history',
    component: Runs,
    meta: {
      title: 'Run History',
      requiresAuth: true
    }
  },
  {
    path: '/swagger',
    name: 'swagger',
    component: Swagger,
    meta: {
      title: 'Swagger API',
      requiresAuth: true
    }
  },
  {
    path: '/frontends',
    name: 'frontends',
    component: Frontends,
    meta: {
      title: 'Frontends',
      requiresAuth: true,
      requiresAnyPermission: ["can_use_frontend", "view_frontend"]
    },
  },
  {
    path: '/vault',
    name: 'vault',
    component: Vault,
    meta: {
      title: 'Vault',
      requiresAuth: true,
      requiresVault: true
    }
  },
  {
    path: '/migrate',
    name: 'migrate',
    component: Migrate,
    meta: {
      title: 'Migrate',
      requiresAuth: true,
      requiresPermissions: ["can_use_migrate"]
    }
  },
  {
    path: '/log',
    name: 'log',
    component: Log,
    meta: {
      title: 'Log',
      requiresAuth: true,
      requiresPermissions: ["can_use_log"]
    }
  },
  {
    path: '/preferences',
    name: 'preferences',
    component: Preferences,
    meta: {
      title: 'Preferences',
      requiresAuth: true,
    }
  },
  {
    path: '/profile',
    component: ProfileContainer,
    meta: {
      title: 'Profile',
      requiresAuth: true,
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUp,
    meta: {
      title: 'Signup',
      requiresAuth: false,
    }
  },
  {
    path: '/reset-password',
    name: 'passwordreset',
    component: ResetPassword,
    meta: {
      title: 'Reset Password',
      requiresAuth: false,
    }
  },
  {
    path: '/invite',
    name: 'invite',
    component: InviteStepper,
    meta: {
      title: 'Invite',
      requiresAuth: true,
      requiresPermissions: ["can_use_invite"]
    }
  },
  {
    path: '/schedules/dashboard',
    name: 'schedule',
    component: ScheduleDashboard,
    meta: {
      requiresAuth: true,
      requiresAdmin: false
    }
  },
  {
    path: '/schedules/:scheduleId(\\d+)?',
    name: 'schedule-edit',
    component: SchedulerView,
    meta: {
      requiresAuth: true,
      requiresAdmin: false
    }
  },
  {
    path: '/workbench',
    component: Workbench,
    meta: {
      title: 'Workbench',
      requiresAuth: true,
      requiresWorkbenchEnabled: true
    },
    children: [
      {
        path: '',
        name: 'workbench',
        component: WorkbenchWelcome,
      },
      {
        path: ':integrationId(\\d+)',
        name: 'workbench-detail',
        component: WorkbenchCanvas,
      },
    ],
  },
  ...etlRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: "not-found",
    redirect: { name: 'login' }
  }
]


const router = () => {
  const vue_router = createRouter({
    history: createWebHistory(),
    base: "/",
    routes: routes,
    meta: {
      title: 'GLYUE',
      metaTags: []
    },
  })

  vue_router.beforeEach(async (to, from, next) => {
    const store = useUserStore()
    // Skip the auth HTTP call for same-route param-only changes (e.g. mapping page integration/SR selection)
    if (to.name && to.name === from.name) {
      next()
      return
    }
    const [ , data ] = await store.checkUserAuth()
    let landing = store.defaultExperience === "etl"
      ? "workflows"
      : getPreferenceValue("landing-page")
    /// Notification query params are replaced in Build.vue
    if (to.query.notif && data?.connected) {
      let notification = to.query.notif
      updateUserNotificationById(notification, { "isRead": true })
    }

    const cookieURL = Cookies.get("after-login-redirect")
    if (cookieURL) {
      Cookies.remove("after-login-redirect")
    }
    const toQueryNext = to.query.nextPath || to.query.next
    const fromQueryNext = from.query.nextPath || from.query.next

    if (data.connected && cookieURL) {
      try {
        let url = new URL(cookieURL, window.location)
        if (url.origin === window.location.origin) {
          next(false)
          window.location.href = url
        } else {
          next({ name: landing })
        }
      } catch (e) {
        console.error(e)
        console.debug({ cookieURL })
        next({ name: landing })
      }
    }
    else if (!data.connected && cookieURL) {
      next({ name: 'login', query: { nextPath: cookieURL } })
    }
    else if (to.name === "not-found" && !data.connected) {
      Cookies.set("after-login-redirect", to.fullPath, { expires: 1 })
      next({ name: 'login', query: { nextPath: to.fullPath } })
    }
    else if (data.connected && to.name === "login" && toQueryNext) {
      try {
        let url = new URL(toQueryNext, window.location)
        if (url.origin === window.location.origin) {
          next(false)
          window.location.href = url
        } else {
          next({ name: landing })
        }
      } catch (e) {
        console.error(e)
        console.debug({ toQueryNext })
        next({ name: landing })
      }
    }
    else if (data.connected && from.name === "login" && fromQueryNext) {
      try {
        let url = new URL(fromQueryNext, window.location)
        if (url.origin === window.location.origin) {
          next(false)
          window.location.href = url
        } else {
          next({ name: landing })
        }
      } catch (e) {
        console.debug({ fromQueryNext })
        console.error(e)
        next({ name: landing })
      }
    }
    // No need to check `meta` for all matched routes
    // See: https://router.vuejs.org/guide/advanced/meta#Route-Meta-Fields
    else if (!data.connected && to.meta.requiresAuth) {
      next({ name: 'login', query: { nextPath: to.fullPath } })
    } else if (data.connected && to.meta.requiresEtlView && !store.canUseEtl) {
      next({ name: landing })
    }
    else if (data.connected && !to.meta.requiresEtlView && !store.canUseGlyue) {
      next({ name: 'workflows' })
    }
    else if (to.meta.requiresAdmin && !data.admin) {
      next({ name: landing })
    }
    else if (to.meta.requiresStaffAdmin && !(data.staff || data.admin)) {
      next({ name: landing })
    }
    else if (to.meta.requiresVault && !data.vault) {
      next({ name: landing })
    }
    else if (
      to.meta.requiresAnyPermission?.length > 0
      && !to.meta.requiresAnyPermission.some((permission) => store.hasPermission(permission))
    ) {
      next({ name: landing })
    }
    else if (
      to.meta.requiresPermissions?.length > 0
      && to.meta.requiresPermissions.some((permission) => !store.hasPermission(permission))
    ) {
      next({ name: landing })
    }
    else if (data.connected && to.name === 'login') {
      next({ name: landing })
    }
    else if (to.meta.requiresWorkbenchEnabled && !useInstallationStore().workbench_enabled) {
      next({ name: landing })
    }
    else if (to.meta.requiresMappingEnabled && useInstallationStore().mapping_enabled === false) {
      next({ name: landing })
    }
    else {
      next()
    }
  })

  vue_router.afterEach((to) => {
    const store = useUserStore()
    setDocumentTitlePage(to, store.name)
  })

  return vue_router
}

export default router
